import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import ProfileBrief from './ProfileBrief'
import ProgressTracker from './ProgressTracker'
import Announcements from './Announcements'
import { getLevelKeyFromCode } from './utils/progressUtils'
import { LEVEL } from './utils/constants/levels'
import { isSuspended, isGptpSuspended } from '../../utils'
import {
  DashboardContainer,
  ContentGrid,
  MainContent,
  SidebarContent
} from './Styles/Dashboard.styles'

const MembershipJourneyDashboard = ({ 
  me, 
  levelState,
  programHistory,
  prospect,
  onEditProfile, 
  history, 
  announcements
}) => {
  const hasSuspension = isSuspended(me) || isGptpSuspended(me)
  const initialLevel = getLevelKeyFromCode(levelState?.currentLevelCode) || LEVEL.QUALIFYING
  const [activeLevel, setActiveLevel] = useState(initialLevel)

  const handleEditClick = () => {
    if (onEditProfile) {
      onEditProfile()
    } else if (history) {
      history.push('/profile/edit')
    } else {
      window.location.href = '/profile/edit'
    }
  }

  return (
    <DashboardContainer>
      <ProfileBrief
        me={me}
        levelState={levelState}
        onEditClick={handleEditClick}
        authReady={true}
      />
      <ContentGrid>
        <MainContent>
          <ProgressTracker
            levelState={levelState}
            activeLevel={activeLevel}
            onLevelClick={setActiveLevel}
            programHistory={programHistory}
            prospect={prospect}
            currentLevelCode={levelState?.currentLevelCode}
            isSuspended={hasSuspension}
          />
        </MainContent>
        <SidebarContent>
          <Announcements announcements={announcements} />
        </SidebarContent>
      </ContentGrid>
    </DashboardContainer>
  )
}

export default withRouter(MembershipJourneyDashboard)
